<template>
  <div :id="`enrichment-${pageId}`" class="c-book-page-enrichments">
    <div class="c-book-page-enrichments__toggle"  @click="toggleOpen">
      <button class="c-book-page-enrichments__button" :class="{'c-book-page-enrichments__button--rotate': isOpen}">
        <arrow-icon class="c-book-page-enrichments__nitpicking"></arrow-icon>
      </button>
    </div>
    <div v-show="isOpen" class="c-book-page-enrichments__wrapper">
      <div v-html="enrichmentPage" class="c-book-page-enrichments__content"></div>
    </div>
  </div>
</template>

<script>
import Arrow from '@/assets/svg/Arrow'

export default {
  name: 'BookPageEnrichments',

  data() {
    return {
      isOpen: false,
      enrichmentPage: ''
    }
  },

  props: {
    enrichments: Object,
    pageId: String
  },

  components: {
    'arrow-icon': Arrow
  },

  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
      this.$emit('toggle-enrichments', this.isOpen)
    },

    async loadEnrichment() {
      this.enrichmentPage = await (await fetch(this.$root.$config.dpm_url + this.enrichments.extraURL)).text()
    },

    getScripts () {
      const docScripts = Array.from(document.querySelectorAll(`#enrichment-${this.pageId} .c-book-page-enrichments__wrapper script`))

      for (let i = 0; i < docScripts.length; i++) {
        const scriptTag = document.createElement('script')
        const target = document.querySelector(`#enrichment-${this.pageId} .c-book-page-enrichments__wrapper div`)

        if (docScripts[i].type) {
          scriptTag.setAttribute('type', docScripts[i].type)
        }

        if (docScripts[i].id) {
          scriptTag.id = docScripts[i].id
        }

        if (docScripts[i].defer) {
          scriptTag.defer = 'defer'
        }

        scriptTag.innerHTML = docScripts[i].innerHTML

        if (docScripts[i].src) {
          scriptTag.src = docScripts[i].src
        }

        target.append(scriptTag)
      }
    },

    loadTemplateScripts() {
      const loadMustacheIfReady = () => setTimeout(() => {
        if (window.Mustache && typeof window.Mustache !== 'undefined' && window.Dynamic && typeof window.Dynamic !== 'undefined') {
          const templateTargets = Array.from(document.querySelectorAll('[data-variable-name]'))
          if (this.pageId === 'page_1') {
            window.Dynamic.enrichments(templateTargets[0])
          } else {
            const secondTemplate = templateTargets[1] || templateTargets[0]
            window.Dynamic.enrichments(secondTemplate)
          }
        } else {
          loadMustacheIfReady()
        }
      }, 100)

      loadMustacheIfReady()
    }
  },

  async mounted() {
    await this.loadEnrichment()
    this.getScripts()
    this.loadTemplateScripts()
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';

.c-book-page-enrichments__toggle {
  height: 3.5rem;
  background: $dark-blue;
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
}

.c-book-page-enrichments__button {
  background: $white;
  border: none;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;

  cursor: pointer;

  &--rotate {
    transform: rotate(180deg);
  }
}

.c-book-page-enrichments__nitpicking {
  margin-top: -1px;
}

.c-book-page-enrichments__content {
  padding: 2rem;
}
</style>
